import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/constants";

/* Modulo di attivazione: dati di fatturazione + le due caselle obbligatorie.
   Senza le spunte il pagamento non parte. `prova` usa la modalità di prova di Stripe. */

const inputCls = "w-full mt-1 bg-white border border-[#D9D2C5] rounded px-3 py-2.5 text-[#0D1527] text-sm";

export const QmdpAttivazioneForm = ({ prova = false, onChiudi }) => {
  const [f, setF] = useState({ nome: "", email: "", partita_iva: "", codice_fiscale: "", sdi: "", pec: "" });
  const [condizioni, setCondizioni] = useState(false);
  const [inizio, setInizio] = useState(false);
  const [err, setErr] = useState(null);
  const [invio, setInvio] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const piva = f.partita_iva.replace(/[^0-9]/g, "");
  const cf = f.codice_fiscale.replace(/[^0-9A-Za-z]/g, "");
  const pronto = condizioni && inizio && f.nome.trim().length > 1 && f.email.includes("@")
    && piva.length === 11 && (cf.length === 16 || cf.length === 11);

  const paga = async () => {
    setErr(null); setInvio(true);
    try {
      const { data } = await axios.post(`${API}/qmdp/attiva`, {
        ...f, accetta_condizioni: condizioni, inizio_immediato: inizio,
        prova, origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (e) {
      setErr(e.response?.data?.detail || "Non siamo riusciti ad aprire il pagamento: riprova tra poco.");
      setInvio(false);
    }
  };

  return (
    <div className="mt-6 border-t border-[#E8E2D5] pt-6" data-testid="qmdp-form-attivazione">
      {prova && (
        <p className="text-[#8A6A28] text-[11px] tracking-[0.2em] mb-3">MODALITÀ DI PROVA · CARTA 4242 4242 4242 4242</p>
      )}
      <div className="space-y-3">
        <label className="block">
          <span className="text-[#64708A] text-xs">Nome e cognome (o ragione sociale)</span>
          <input value={f.nome} onChange={(e) => set("nome", e.target.value)} className={inputCls} data-testid="attiva-nome" />
        </label>
        <label className="block">
          <span className="text-[#64708A] text-xs">Email</span>
          <input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} className={inputCls} data-testid="attiva-email" />
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="text-[#64708A] text-xs">Partita IVA</span>
            <input value={f.partita_iva} onChange={(e) => set("partita_iva", e.target.value)} className={inputCls}
              inputMode="numeric" placeholder="11 cifre" data-testid="attiva-piva" />
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">Codice fiscale</span>
            <input value={f.codice_fiscale} onChange={(e) => set("codice_fiscale", e.target.value.toUpperCase())}
              className={inputCls} data-testid="attiva-cf" />
          </label>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="text-[#64708A] text-xs">Codice destinatario SDI <span className="text-[#9AA3B2]">(facoltativo)</span></span>
            <input value={f.sdi} onChange={(e) => set("sdi", e.target.value.toUpperCase())} className={inputCls}
              placeholder="7 caratteri" data-testid="attiva-sdi" />
          </label>
          <label className="block">
            <span className="text-[#64708A] text-xs">PEC <span className="text-[#9AA3B2]">(facoltativa)</span></span>
            <input value={f.pec} onChange={(e) => set("pec", e.target.value)} className={inputCls}
              data-testid="attiva-pec" />
          </label>
        </div>
        <p className="text-[#8E9AAE] text-[11px]">
          Servono per la fattura elettronica. Se non indichi SDI o PEC, la fattura la trovi nel tuo cassetto fiscale.
          L'indirizzo te lo chiede Stripe nella pagina del pagamento.
        </p>
      </div>

      <label className="flex items-start gap-2 mt-5 cursor-pointer">
        <input type="checkbox" checked={condizioni} onChange={(e) => setCondizioni(e.target.checked)}
          className="mt-1" data-testid="attiva-condizioni" />
        <span className="text-[#4A5568] text-xs">
          Ho letto e accetto le{" "}
          <Link to="/strumenti/quanto-mettere-da-parte/condizioni" target="_blank" className="text-[#2F7DBF] underline">
            condizioni generali
          </Link>{" "}
          del servizio.
        </span>
      </label>
      <label className="flex items-start gap-2 mt-3 cursor-pointer">
        <input type="checkbox" checked={inizio} onChange={(e) => setInizio(e.target.checked)}
          className="mt-1" data-testid="attiva-inizio" />
        <span className="text-[#4A5568] text-xs">
          Chiedo che il servizio inizi subito e so che, se recedo entro 14 giorni, mi verrà rimborsato il canone
          meno la parte corrispondente ai giorni già usati.
        </span>
      </label>

      {err && <p className="text-red-600 text-sm mt-4" data-testid="attiva-errore">{err}</p>}
      <button onClick={paga} disabled={!pronto || invio} data-testid="attiva-paga"
        className="w-full mt-5 px-6 py-3.5 rounded bg-[#2F7DBF] text-white font-bold tracking-wide hover:bg-[#1F4E75] transition-colors disabled:opacity-40">
        {invio ? "APERTURA DEL PAGAMENTO…" : "VAI AL PAGAMENTO · 9,90 € AL MESE"}
      </button>
      {!pronto && (
        <p className="text-[#8E9AAE] text-xs mt-2" data-testid="attiva-blocco">
          Per proseguire servono nome, email, partita IVA (11 cifre), codice fiscale e le due spunte qui sopra.
        </p>
      )}
      {onChiudi && (
        <button onClick={onChiudi} className="text-[#8E9AAE] text-xs mt-3 underline" data-testid="attiva-annulla">
          Annulla
        </button>
      )}
    </div>
  );
};
